var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
// import { compatibleResize } from "./compatible"
import { LandscapeDisplayContext } from "./context";
import { autoCalcRotate, register, setRotateStyle, unregister } from "./core";
import { injectGlobal } from "./injectGlobal";
import styles from "./index.css";
export var LandscapeDisplay = function (_a) {
    var inRotate = _a.inRotate, children = _a.children;
    var _b = __read(useState({
        width: 0,
        height: 0,
        inRotate: false,
    }), 2), ctx = _b[0], setCtx = _b[1];
    useEffect(function () {
        var timer;
        var syncCtx = function () {
            if (timer)
                clearTimeout(timer);
            var ctx = setRotateStyle(inRotate !== null && inRotate !== void 0 ? inRotate : autoCalcRotate());
            setCtx(function (prev) {
                if (ctx.height === prev.height &&
                    ctx.width === prev.width &&
                    ctx.inRotate === prev.inRotate)
                    return prev;
                return ctx;
            });
        };
        var handler = function () {
            syncCtx();
            timer = setTimeout(function () { return syncCtx(); }, 160);
        };
        register(handler);
        var remove = injectGlobal([styles.global]);
        return function () {
            unregister(handler);
            remove();
        };
    }, [inRotate]);
    return (_jsx(LandscapeDisplayContext.Provider, { value: ctx, children: children }));
};
